import React from 'react'

import ExploreDbEntity from '../../components/DbEntities/Explore'

export default () => <ExploreDbEntity dbEntityType='shoes' />

